
import { Component, Mixins } from "vue-property-decorator";
import { FuzzyDate } from "../../../../../../domain/system/FuzzyDate";
import {
  ISingleSelectableAsynchronously,
  ISingleSelectableConditionallyAsynchronously,
} from "../../../../../system";
import { DialogMixin } from "../../../../../system/mixins";
import { IFuzzyDateSelectCondition } from "../IFuzzyDateSelectCondition";

@Component({
})
export default class FuzzyDateSelectableDialogMixin extends Mixins(
  DialogMixin
) implements
  ISingleSelectableAsynchronously<FuzzyDate>,
  ISingleSelectableConditionallyAsynchronously<FuzzyDate, IFuzzyDateSelectCondition> {
  data(): any {
    return {
      selectedDate: null as Date,
      selectedInfo: null as FuzzyDate,
      condition: {
        title: "日時",
        format: "",
        enableApproximateInput: false,
      },
    };
  }
  selectedDate: Date;
  selectedInfo: FuzzyDate;
  isAppliedValue: boolean;
  condition: IFuzzyDateSelectCondition;

  get selectedYear(): number {
    return this.selectedDate.getFullYear();
  }

  get selectedMonth(): number {
    return this.selectedDate.getMonth() + 1;
  }

  get selectedDayOfMonth(): number {
    return this.selectedDate.getDate();
  }

  get selectedHours(): number {
    return this.selectedDate.getHours();
  }

  get selectedMinutes(): number {
    return this.selectedDate.getMinutes();
  }

  get selectedSeconds(): number {
    return this.selectedDate.getSeconds();
  }

  suppressBlanks(source: string): string {
    return source.replace(/ +/g, "");
  }

  now(): Date {
    return new Date();
  }

  today(): Date {
    return new Date(
      this.now().getFullYear(),
      this.now().getMonth(),
      this.now().getDate()
    );
  }

  // 定数.
  readonly indeterminationAsString: string = "不詳";
  readonly unknownAsString: string = "不明";

  async selectOption(date: FuzzyDate): Promise<FuzzyDate> {
    return this.showModal(async () => {
      this.selectedDate = (date.value instanceof Date)
        ? date.value as Date
        : (date.linkedDate ? date.linkedDate : new Date());
      this.selectedInfo = date;
      this.isAppliedValue = false;
      await this.waitHidden();
      if (!this.isAppliedValue) {
        this.selectedInfo = null;
      }
      return this.selectedInfo;
    });
  }

  async selectOptionConditionally(condition: IFuzzyDateSelectCondition, date: FuzzyDate): Promise<FuzzyDate> {
    this.condition = condition;
    return this.selectOption(date);
  }

  applyValue(value: Date | string, shouldSetLinkedDate?: boolean): void {
    this.selectedInfo.value = value;
    this.selectedInfo.linkedDate = (shouldSetLinkedDate && this.selectedDate) ? new Date(this.selectedDate) : null;
    this.isAppliedValue = true;
    this.isVisible = false;
  }

  cancel(): void {
    this.isVisible = false;
  }
}
